import {ColorPalette} from '../utils/constants'

export const colors = {
  light: {
    main: ColorPalette.WHITE,
    secondary: '#ccd9cb',
  },
  primary: {
    main: ColorPalette.BLUE_NCS,
    hover: ColorPalette.BLUE_NCS_HOVER,
    500: '#6e67f3e6',
  },
  dark: {
    main: ColorPalette.DARK_LIVER_HORSES,
  },
  success: {
    main: ColorPalette.GREEN_YELLOW_CRAYOIA,
  },
  error: {
    main: ColorPalette.CINNEBAR,
  },
  border: {
    main: ColorPalette.BORDER_COLOR,
  },
}
